(function () {
  'use strict';

  function sidebarMyOrderFactory (Common, $http, paymentFactory) {
    const factory = {};

    factory.sidebarDetails = {};

    function getSidebarDetails (landingSelection) {
      factory.sidebarDetails.serviceType = Common.get('serviceType', landingSelection || '');
      factory.sidebarDetails.recipients = Common.get('recipients.validAddressCount', 0);
      factory.sidebarDetails.product = Common.get('productDelivery', {});
      factory.sidebarDetails.pricing = paymentFactory.extractCalculatedPrice();
      factory.sidebarDetails.materialDetails = Common.get('materialDetails', {});
      factory.sidebarDetails.sendoutName = Common.get('sendoutName', '');
    }

    function fetchPricesFromBackend (options) {
      $http.post(web2print.env.pricingBaseUrl + 'calculatePrice', options)
        .then(function (response) {
          let pricing = response.data;

          if (!pricing.total) {
            pricing = {};
          }

          Common.set('pricing', pricing);

          if (Common.checkObserver('updatePaymentPriceDetails')) {
            Common.notifyObserver('updatePaymentPriceDetails');
          }

          getSidebarDetails();
        },
        function (error) {
          console.log(error);
          Common.set('pricing', {});
        });
    }

    function checkAndRegisterObserver (observer) {
      if (!Common.checkObserver(observer)) {
        Common.registerObserver(observer.name, observer.cb);
      }
    }

    function registerObservers (observers) {
      observers.forEach(checkAndRegisterObserver);
    }

    function setSidebarModel (key, value) {
      factory.sidebarDetails[key] = value;
    }

    factory.getSidebarDetails = getSidebarDetails;
    factory.fetchPricesFromBackend = fetchPricesFromBackend;
    factory.registerObservers = registerObservers;
    factory.setSidebarModel = setSidebarModel;
    factory.addressProcessing = false;

    return factory;
  }

  angular.module('web2print.sidebar.myorder')
    .factory('sidebarMyOrderFactory', sidebarMyOrderFactory);
})();
